<a style="cursor: pointer" (click)="getCert()">{{ 'core.certificates.download' | translate }}</a>
